var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "profile_modal",
      staticClass: "modal-backdrop-transparent",
      attrs: {
        size: "lg",
        bodyClass: "p-0",
        "no-close-on-backdrop": false,
        "hide-header": true,
        "hide-footer": true,
        dialogClass: _vm.dialog_class_draw,
      },
      model: {
        value: _vm.is_show_modal,
        callback: function ($$v) {
          _vm.is_show_modal = $$v
        },
        expression: "is_show_modal",
      },
    },
    [
      _c("ul", { staticClass: "app-list w-auto h-auto p-0 text-left" }, [
        _c("li", [
          _c(
            "a",
            {
              staticClass: "app-list-item text-white border-0 m-0",
              attrs: { href: "/" },
            },
            [
              _c("div", { staticClass: "icon-stack" }, [
                _c("i", {
                  staticClass:
                    "base base-7 icon-stack-3x opacity-100 color-primary-500",
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass:
                    "base base-7 icon-stack-2x opacity-100 color-primary-300",
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass:
                    "fal fa-home icon-stack-1x opacity-100 color-white",
                }),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "app-list-name" }, [
                _vm._v("\n                     MAIN\n                "),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              staticClass: "app-list-item text-white border-0 m-0",
              attrs: { target: "_blank", href: "/go_direct_service/orders" },
            },
            [
              _c("div", { staticClass: "icon-stack" }, [
                _c("i", {
                  staticClass:
                    "base base-7 icon-stack-3x opacity-100 color-success-500",
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass:
                    "base base-7 icon-stack-2x opacity-100 color-success-300",
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "ni ni-envelope icon-stack-1x text-white",
                }),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "app-list-name" }, [
                _vm._v("\n                       GO_ORDERS\n                "),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              staticClass: "app-list-item text-white border-0 m-0",
              attrs: { target: "_blank", href: "/go_direct_service/preview" },
            },
            [
              _c("div", { staticClass: "icon-stack" }, [
                _c("i", {
                  staticClass:
                    "base base-7 icon-stack-3x opacity-100 color-success-500",
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass:
                    "base base-7 icon-stack-2x opacity-100 color-success-300",
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "ni ni-envelope icon-stack-1x text-white",
                }),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "app-list-name" }, [
                _vm._v("\n                    GO_PREVIEW\n                "),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              staticClass: "app-list-item text-white border-0 m-0",
              attrs: { target: "_blank", href: "/go_direct_service/partners" },
            },
            [
              _c("div", { staticClass: "icon-stack" }, [
                _c("i", {
                  staticClass:
                    "base base-7 icon-stack-3x opacity-100 color-success-500",
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass:
                    "base base-7 icon-stack-2x opacity-100 color-success-300",
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "ni ni-envelope icon-stack-1x text-white",
                }),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "app-list-name" }, [
                _vm._v("\n                    GO_PARTNERS\n                "),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              staticClass: "app-list-item text-white border-0 m-0",
              attrs: { target: "_blank", href: "/go_direct_service/analytics" },
            },
            [
              _c("div", { staticClass: "icon-stack" }, [
                _c("i", {
                  staticClass:
                    "base base-7 icon-stack-3x opacity-100 color-success-500",
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass:
                    "base base-7 icon-stack-2x opacity-100 color-success-300",
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "ni ni-envelope icon-stack-1x text-white",
                }),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "app-list-name" }, [
                _vm._v("\n                    GO_ANALYTICS\n                "),
              ]),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }